<template>
	<section>
		<h2 class="onboarding-title">Allergy watch</h2>
		<p class="onboarding-text lead">
			Share any allergens so our meal suggestions can keep you safe and
			confident.
		</p>
		<div class="form-group">
			<label class="form-label" for="onboarding-allergies">Allergies</label>
			<textarea
				id="onboarding-allergies"
				rows="3"
				class="form-control"
				v-model="model"
				:disabled="none"
				placeholder="peanuts, gluten, shellfish..." />
		</div>
		<div class="form-check skip-check">
			<input
				id="onboarding-no-allergies"
				type="checkbox"
				class="form-check-input"
				v-model="none" />
			<label class="form-check-label" for="onboarding-no-allergies">
				I don't have any allergies
			</label>
		</div>
		<p class="onboarding-hint">
			<i class="bi bi-shield-check"></i>
			We'll highlight dishes that contain anything on your list.
		</p>
	</section>
</template>

<script setup>
	import { computed, watch } from "vue"

	const props = defineProps({
		modelValue: {
			type: String,
			default: "",
		},
		noneSelected: {
			type: Boolean,
			default: false,
		},
	})

	const emit = defineEmits(["update:modelValue", "update:noneSelected"])

	const model = computed({
		get: () => (props.noneSelected ? "" : props.modelValue ?? ""),
		set: (value) => emit("update:modelValue", value),
	})

	const none = computed({
		get: () => props.noneSelected ?? false,
		set: (value) => emit("update:noneSelected", value),
	})

	watch(none, (value) => {
		if (value) {
			emit("update:modelValue", "")
		}
	})

	watch(model, (value) => {
		if (value && none.value) {
			emit("update:noneSelected", false)
		}
	})
</script>

<style scoped>
	.skip-check {
		margin-top: 0.5rem;
	}

	.onboarding-hint {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		margin-top: 0.75rem;
		padding: 0.5rem 0.75rem;
		background: rgba(56, 189, 248, 0.15);
		color: #0369a1;
		border-radius: 12px;
		font-weight: 600;
	}

	.onboarding-hint i {
		font-size: 1.1rem;
	}
</style>
